export const startsWith = (stringToSearch, text) => {
    if(!stringToSearch || !text || stringToSearch.length < text.length) {
        return false;
    }
    return stringToSearch.substring(0, text.length) === text;
};